import { styled } from '@planne-software/uni/mui/material';
import type { TimeCellProps } from './types';

export const TimeCellRoot = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'error',
})<TimeCellProps>(({ theme, error, isSelected }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '2.5rem',
  minWidth: 0,
  padding: `${theme.tokens.spacing['spacing-1xmini']}`,
  borderRadius: theme.tokens.radius['border-radius-xs'],
  border: 'none',
  ...theme.typography['text-sm-medium'],

  ...(error && {
    cursor: 'not-allowed',
    backgroundColor: theme.tokens.colors['fill-color-neutral-softest'],
    color: theme.tokens.colors['text-color-neutral-softer'],
  }),

  ...(!error &&
    isSelected && {
      cursor: 'pointer',
      backgroundColor: theme.tokens.colors['fill-color-primary-stronger'],
      color: theme.palette.common.white,
    }),

  ...(!error &&
    !isSelected && {
      cursor: 'pointer',
      backgroundColor: theme.tokens.colors['fill-color-success-softer'],
      color: theme.tokens.colors['text-color-success-stronger'],
    }),

  '&:disabled': {
    cursor: 'not-allowed',
    backgroundColor: theme.tokens.colors['fill-color-neutral-softest'],
    color: theme.tokens.colors['text-color-neutral-soft'],
  },
}));
